import React from "react";
import loadable from "@loadable/component";
const RemoteAreaComponent = loadable(
  () => import("../../components/RemoteArea/RemoteArea")
);
const RemoteArea = () => {
  return (
    <div>
      <RemoteAreaComponent />
    </div>
  );
};

export default RemoteArea;
